export default __webpack_public_path__ + "static/media/TuVotoSi.16953dd4.png";